export default __webpack_public_path__ + "static/media/icon_mydata_requesting.bedbfccb.svg";